'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _admin = require('./admin.html');

var _admin2 = _interopRequireDefault(_admin);

var _admin3 = require('./admin.controller');

var _admin4 = _interopRequireDefault(_admin3);

require('./admin.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adminComponent = {
  restrict: 'E',
  bindings: {},
  template: _admin2.default,
  controller: _admin4.default,
  controllerAs: 'vm'
};

exports.default = adminComponent;


// WEBPACK FOOTER //
// ./client/app/components/admin/admin.component.js